"use client";

import dynamic from "next/dynamic";

const AgentationInner = dynamic(() => import("agentation").then(mod => ({ default: mod.Agentation })), { ssr: false });

export function DevAgentation() {
  if (process.env.NODE_ENV !== "development" || !process.env.NEXT_PUBLIC_ENABLE_AGENTATION) return null;
  return (
    <AgentationInner
      endpoint="http://localhost:4747"
      onSessionCreated={sessionId => {
        console.log("Session started:", sessionId);
      }}
    />
  );
}
